const { defer, never } = require('rxjs');

/**
 * @ngdoc service
 * @name posApp.payPlazaStreams
 * @description
 * Service that exposes {@link posApp.payPlazaRequests payPlazaRequests}
 * methods as streams
 */
angular
  .module('posApp')
  .factory('payPlazaStreams', function (payPlazaRequests) {
    const payPlazaStreams = this;
    let abort$ = never();

    /**
     * @ngdoc
     * @name posApp.payPlazaStreams#add
     * @methodOf posApp.payPlazaStreams
     *
     * @description
     * Sets new abort stream - ie when it emits; all requests are supposed to be dropped
     * @param {Observable} newAbort$ abort stream
     * @return {void} Nothing
     */
    // TODO unit tests
    payPlazaStreams.setAbortStream = (newAbort$) => {
      abort$ = newAbort$;
    };

    /**
     * @ngdoc
     * @name posApp.payPlazaStreams#createSendTransactionResponseMessageStream
     * @methodOf posApp.payPlazaStreams
     *
     * @description
     * Creates an ad-hoc stream of calls to {@link posApp.payPlazaRequests#sendTransactionResponseMessage
     * posApp.payPlazaRequests#sendTransactionResponseMessage} with arguments
     * @param {String} merchRef
     * reference saved on the transaction to match entities in both systems
     * @param {string} amount
     * Transaction amount, with 2 decimal numbers
     * @param {promise} cancelPromise
     * a promise that will break the request if it's resolved
     * @return {Observable} request stream
     */
    // TODO unit tests
    payPlazaStreams.createSendTransactionResponseMessageStream = (
      merchRef,
      amount,
    ) =>
      defer(() =>
        payPlazaRequests.sendTransactionStartMessage(
          merchRef,
          amount,
          abort$.toPromise(),
        ),
      );

    // TODO add documentation
    // TODO unit tests
    payPlazaStreams.connect$ = defer(() =>
      payPlazaRequests.connect(undefined, abort$.toPromise()),
    );

    payPlazaStreams.disconnect$ = defer(() =>
      payPlazaRequests.disconnect(abort$.toPromise()),
    );

    payPlazaStreams.poll$ = defer(() =>
      payPlazaRequests.poll(abort$.toPromise()),
    );

    payPlazaStreams.requestReprint$ = defer(() =>
      payPlazaRequests.requestReprint(abort$.toPromise()),
    );

    payPlazaStreams.sendPrintSuccess$ = defer(() =>
      payPlazaRequests.sendPrintSuccess(abort$.toPromise()),
    );

    return payPlazaStreams;
  });
